<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${currentHeroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Street-Born Style. Everyday Attitude.</div>
          <div class="hero-desc">
            Urban menswear for the modern Indian man — hoodies, jackets, denim, tees and sharp tailoring built to move with your city. Bold silhouettes, honest fabrics, zero compromise.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
        <div class="hero-dots">
          <span
            v-for="(img, idx) in heroImages"
            :key="idx"
            class="hero-dot"
            :class="{ active: heroIndex === idx }"
            @click="setHeroIndex(idx)"
          ></span>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh men's styles just landed</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹499</p>
          </div>
          <div class="why-item">
            <div class="why-icon">👔</div>
            <h3>Premium Quality</h3>
            <p>Curated fabrics &amp; fine craftsmanship</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>UPI, COD &amp; cards accepted</p>
          </div>
        </div>

        <!-- Shop By Category Tiles -->
        <div class="home-section cat-section">
          <div class="home-section-header">
            <div>
              <h2>Shop By Category</h2>
              <p>Eight edits, one wardrobe</p>
            </div>
            <router-link class="section-cta" to="/goods">See All</router-link>
          </div>
          <div class="cat-tiles">
            <router-link
              v-for="tile in categoryTiles"
              :key="tile.id"
              class="cat-tile"
              :to="`/goods?categoryID=${tile.id}`"
            >
              <span class="cat-tile-accent"></span>
              <img :src="tile.img" :alt="tile.name" loading="lazy" />
              <span class="cat-tile-label">{{ tile.name }}</span>
            </router-link>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Shop The Edit</h2>
              <p>Eight edits from tees to tailoring — pick your lane</p>
            </div>
            <div class="section-tabs">
              <span
                v-for="tab in discoverTabs"
                :key="tab.key"
                class="tab-item"
                :class="{active: discoverActive===tab.key}"
                @click="discoverActive=tab.key"
              >{{ tab.label }}</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>STREET SEASON 2026</h2>
            <p>Up to 40% Off on Hoodies, Jackets &amp; Tees</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/37670311/img_00.jpg" alt="GAP Logo Printed Hooded Sweatshirt" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Polo &amp; Casual T-Shirts</div>
              <div class="split-desc">
                Breathable cotton polos and printed tees — easy staples that pair effortlessly with denim, chinos or shorts.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=31">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/33888242/img_00.jpg" alt="Polo Collar Drop-Shoulder T-shirt" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Monsoon-Ready Outerwear</div>
              <div class="split-desc">
                Waterproof shells and longline rain jackets for the Indian monsoon — packable, breathable, built to outlast the downpour.
              </div>
              <router-link class="section-cta" to="/goods?categoryID=38">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/18350122/img_00.jpg" alt="Wildcraft Men Red Rain Jacket" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据（后端接口，已忽略：Hero 由下方精选男装图池提供）
      // Discover 区：8 个男装分类 tab（category_id 对应 sql/男装.sql 的 product_cat_id 31-38）
      discoverTabs: [
        { key: 'TSHIRTS', id: 31, label: 'TSHIRTS' },
        { key: 'CASUAL', id: 32, label: 'CASUAL SHIRTS' },
        { key: 'FORMAL', id: 33, label: 'FORMAL SHIRTS' },
        { key: 'SWEATSHIRTS', id: 34, label: 'SWEATSHIRTS' },
        { key: 'JACKETS', id: 35, label: 'JACKETS' },
        { key: 'BLAZERS', id: 36, label: 'BLAZERS' },
        { key: 'SUITS', id: 37, label: 'SUITS' },
        { key: 'RAIN', id: 38, label: 'RAIN JACKETS' }
      ],
      discoverActive: 'TSHIRTS', // Discover section active tab
      discoverLists: {}, // key -> 商品列表
      // Shop By Category 分类卡片（8 张，来自 sql/男装.sql img_path，OSS shop5 路径）
      categoryTiles: [
        { id: 31, name: 'Men T-Shirts', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/40619295/img_00.jpg' },
        { id: 32, name: 'Casual Shirts', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/28449354/img_00.jpg' },
        { id: 33, name: 'Formal Shirts', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/39077711/img_00.jpg' },
        { id: 34, name: 'Sweatshirts', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/39302488/img_00.jpg' },
        { id: 35, name: 'Jackets', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/35746977/img_00.jpg' },
        { id: 36, name: 'Blazers', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/27914868/img_00.jpg' },
        { id: 37, name: 'Suits', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/38665324/img_00.jpg' },
        { id: 38, name: 'Rain Jackets', img: 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/29651774/img_00.jpg' }
      ],
      // Hero 轮播：精选男装图池（OSS shop5 路径，来自 sql/男装.sql img_path）
      heroImages: [
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/32525705/img_00.jpg', // Peter England Elite Three-Piece Suit
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/36923723/img_00.jpg', // Tommy Hilfiger Textured Blazer
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/26664580/img_00.jpg', // Royal Enfield Windfarer V2 Riding Jacket
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/40339258/img_00.jpg', // INVICTUS Slim Fit Formal Shirt
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/38736825/img_00.jpg'  // THE SHIRT CODE Striped Casual Shirt
      ],
      heroIndex: 0,
      heroTimer: null,
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    currentHeroImage() {
      // 直接使用精选男装图池，忽略后端 carousels
      return this.heroImages[this.heroIndex] || this.heroImages[0]
    },
    discoverProducts() {
      return this.discoverLists[this.discoverActive] || []
    }
  },
  activated() {
    // 获取首页数据
    this.load()
    this.startHeroRotation()
  },
  deactivated() {
    this.stopHeroRotation()
  },
  beforeDestroy() {
    this.stopHeroRotation()
  },
  methods: {
    // Hero 轮播控制
    setHeroIndex(idx) {
      this.heroIndex = idx
    },
    startHeroRotation() {
      this.stopHeroRotation()
      if (!this.heroImages || this.heroImages.length < 2) return
      this.heroTimer = setInterval(() => {
        this.heroIndex = (this.heroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroRotation() {
      if (this.heroTimer) {
        clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    load() {
      // 不再请求后端 carousels 接口。Hero 轮播由精选男装图池提供。
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      // Discover section: 8 个男装分类（类别 id 直接用 product_cat_id 31-38）
      this.loadDiscover()
    },
    // Discover 区：按 8 个 tab 拉取商品
    loadDiscover() {
      this.discoverTabs.forEach(tab => {
        productsAPI
          .listProducts(tab.id, 0, this.limit)
          .then(res => {
            if (res.status === 200) {
              this.$set(this.discoverLists, tab.key, this.shuffle((res.data && res.data.items) || []))
            }
          })
          .catch(() => {})
      })
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#FFFFFF')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';

/* Shop By Category Tiles（Digimart Fashion） */
.cat-section .cat-tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 8px 0 44px;
}
.cat-section .cat-tile {
  position: relative;
  display: block;
  border-radius: 14px;
  overflow: hidden;
  background: #F4F4F2;
  text-decoration: none;
}
.cat-section .cat-tile img {
  width: 100%;
  height: 230px;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}
.cat-section .cat-tile:hover img {
  transform: scale(1.05);
}
.cat-section .cat-tile-accent {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #D7FF3E;
}
.cat-section .cat-tile-label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 22px 14px 12px;
  background: linear-gradient(180deg, rgba(11, 11, 13, 0) 0%, rgba(11, 11, 13, 0.85) 100%);
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}
@media (max-width: 900px) {
  .cat-section .cat-tiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .cat-section .cat-tile img {
    height: 160px;
  }
}
</style>
